window.SystemPayService = {
    /**
     * Initialise un paiement via SystemPay et le Cloudflare Worker
     * @param {Object} options
     */
    initPayment: function(options) {
        var workerUrl = options.workerUrl;
        var paymentData = options.paymentData;
        var onReady = options.onReady;
        var onError = options.onError;
        var onFail = options.onFail;
        var onSuccess = options.onSuccess;

        try {
            var sessionId = sessionStorage.getItem('payment_session_id');
            if (!sessionId) {
                sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substring(2, 15);
                sessionStorage.setItem('payment_session_id', sessionId);
            }

            var xhr = new XMLHttpRequest();
            xhr.open('POST', workerUrl + '/api/payment/create');
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('X-Session-ID', sessionId);

            xhr.onload = function() {
                try {
                    var data = JSON.parse(xhr.responseText);
                    if (xhr.status >= 200 && xhr.status < 300) {
                        if (!data.formToken) {
                            throw new Error('Form token non reçu du serveur');
                        }

                        var initKR = function() {
                            if (typeof KR !== 'undefined' && KR.setFormToken) {
                                var krEmbedded = document.querySelector('.kr-embedded');
                                if (krEmbedded && !krEmbedded.hasAttribute('kr-form-token')) {
                                    krEmbedded.setAttribute('kr-form-token', data.formToken);
                                }

                                KR.setFormToken(data.formToken).then(function() {
                                    // Successfully set token
                                }).catch(function(err) {
                                    if (typeof onError === 'function') onError(err.message || "Erreur KR.setFormToken", err);
                                });
                                
                                KR.onFormReady(function() {
                                    if (typeof onReady === 'function') onReady(data);
                                });

                                KR.onError(function(error) {
                                    sessionStorage.removeItem('payment_session_id');
                                    var errorMessage = 'Une erreur est survenue lors du paiement.';
                                    if (error && typeof error === 'object') {
                                        if (error.errorMessage) errorMessage = error.errorMessage;
                                        else if (error.message) errorMessage = error.message;
                                        else if (error.errorCode) errorMessage = 'Erreur ' + error.errorCode + ': Paiement refusé';
                                    } else if (typeof error === 'string') {
                                        errorMessage = error;
                                    }
                                    if (typeof onError === 'function') onError(errorMessage, error);
                                });

                                KR.onSubmit(function(paymentRes) {
                                    sessionStorage.removeItem('payment_session_id');
                                    if (paymentRes.clientAnswer) {
                                        var status = paymentRes.clientAnswer.orderStatus;
                                        if (status === 'PAID') {
                                            if (typeof onSuccess === 'function') return onSuccess(paymentRes, data);
                                        } else if (status === 'REFUSED') {
                                            if (typeof onFail === 'function') return onFail('Paiement refusé par la banque', paymentRes);
                                            else if (typeof onError === 'function') return onError('Paiement refusé par la banque', paymentRes);
                                        } else {
                                            if (typeof onError === 'function') return onError('Statut de paiement inconnu: ' + status, paymentRes);
                                        }
                                    } else {
                                        if (typeof onError === 'function') return onError('Réponse invalide de SystemPay', paymentRes);
                                    }
                                });
                                
                            } else {
                                setTimeout(initKR, 100);
                            }
                        };
                        
                        initKR();
                    } else {
                        throw new Error(data.error || 'Erreur lors de la création du paiement');
                    }
                } catch (e) {
                    if (typeof onError === 'function') onError(e.message, e);
                }
            };
            
            xhr.onerror = function() {
                if (typeof onError === 'function') onError('Erreur réseau lors de la création du paiement');
            };

            xhr.send(JSON.stringify(paymentData));

        } catch (error) {
            console.error('SystemPayService Error:', error);
            if (typeof onError === 'function') {
                onError(error.message || 'Erreur d\'initialisation du paiement', error);
            }
        }
    }
};
